import { isIOSApp } from "../../../utils/common";

const GuidesBasics: React.FC = () => {
  return (
    <div className="featured-articles-container">
      <p>
        <a href="/" className="breadcrumb-link">
          Help Desk
        </a>{" "}
        &#10132;{" "}
        <a href="/guides" className="breadcrumb-link">
          Guides
        </a>{" "}
        &#10132; Getting started basics
      </p>
      <h2 className="help-heading">Getting started basics on CEO.CA</h2>
      <ol>

        <li>
          <b>Find a Company Channel:</b>
          <ul style={{listStyleType: 'disc'}}>
            <li>
              <b>Locating the Search Function: </b>
              Upon entering the site, you may want to start by looking up a specific company. To do this, simply tap on the magnifying glass icon 
              located in the top right-hand corner of the page or if you are on mobile, click the search button in the bottom task bar.
            </li>
            <li>
              <b>Using the Search Bar: </b>
              Begin typing the ticker symbol of the company you're interested in. As you type, a drop-down box will appear with suggestions.
            </li>
            <li>
              <b>Accessing the Company Channel: </b>
              From the drop-down list, tap or click on the desired company to navigate directly to that company's channel.
            </li>
          </ul>
        </li>

        <br/>

        <li>
          <b>Viewing Company Information:</b>
          <ul style={{listStyleType: 'disc'}}>
            <li>
              <b>Company Panel on Wider Screens: </b> 
              On a wider screen, you'll notice the company panel on the left side of your screen. This panel displays the last price, charts, and other key metrics for the selected company.
            </li>
            <li>
              <b>Expanding the Company Tab: </b>
              On mobile devices or smaller screens, tap on the company tab. This action expands the company panel to fill your screen, making it easier to view detailed information.
            </li>
            {!isIOSApp &&
              <li>
                <b>CEO PRO Subscription Features: </b>
                If you're a CEO PRO subscriber, the company panel will be enhanced with additional features and detailed metrics, offering a more in-depth look at the company.
              </li>
            }
          </ul>
        </li>

        <br/>

        <li>
          <b>Navigating Channels and Discussions:</b>
          <ul style={{listStyleType: 'disc'}}>
            <li>
              <b>Exploring Channels: </b> 
              CEO.CA offers a variety of channels where you can engage in discussions, access news, and get insights. Browse through these channels to find topics or discussions that interest you.
            </li>
            <li>
              <b>Participating in Discussions: </b>
              Join in the conversations by posting comments, questions, or sharing insights. Interact with other users to gain diverse perspectives and valuable information.
            </li>
            <li>
              <b>Using Reply Threads: </b>
              To reply to a specific comment, click on the comment to expand it and use the 'Reply' button. This keeps conversations organized and contextual.
            </li>
          </ul>
        </li>

        <br/>

        <li>
          <b>Customizing Your Experience:</b>
          <ul style={{listStyleType: 'disc'}}>
            <li>
              <b>Setting Preferences: </b> 
              Customize your user experience by adjusting settings in your profile. This includes notification preferences, display options, and more.
            </li>
            <li>
              <b>Following Favorite Channels: </b>
              Mark channels or discussions as favorites for quick access. To do so, click subscribe in the top right corner to add a channel, company or user to a specific watchlist. 
              This helps in keeping track of ongoing discussions or specific companies and allow you to set up individual notifications. 
            </li>
          </ul>
        </li>

        <br/>

        <li>
          <b>Staying Informed and Engaged:</b>
          <ul style={{listStyleType: 'disc'}}>
            <li>
              <b>Real-Time Updates: </b> 
              Stay up-to-date with real-time updates and alerts on companies and topics of interest.
            </li>
            <li>
              <b>Learning and Growth: </b>
              Use the vast resources and community insights on CEO.CA to enhance your understanding of the market and investment strategies.
            </li>
          </ul>
        </li>
      </ol>
      <p>
        Join the CEO.CA community today and start exploring the exciting world of investment and company insights. 
        Whether you're a seasoned investor or just starting out, CEO.CA is your gateway to a wealth of information and a vibrant community.
      </p>
    </div>
  );
};

export default GuidesBasics;
